import React from "react";

import connectToStores from "alt-utils/lib/connectToStores";
import FilmActions from "../actions/FilmActions";
import FilmStore from "../stores/FilmStore";

import WorkingIndicator from "./partials/working-indicator.jsx";

class NewFilm extends React.Component {
  constructor(props) {
    super(props);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  static getStores() {
    return [FilmStore];
  }

  static getPropsFromStores() {
    return {
      newFilmId: FilmStore.getState().newFilmId
    };
  }

  componentWillMount() {
    FilmActions.create({
      name: "",
      event_bucket: this.props.params.eventBucketId
    });
  }

  componentWillReceiveProps(props) {
    if (props.newFilmId) {
      this.context.router.replace(
        `/event_buckets/${props.params.eventBucketId}/films/${props.newFilmId}/edit`
      );
    }
  }

  render() {
    return <WorkingIndicator fullPage={true} />;
  }
}

export default connectToStores(NewFilm);



// WEBPACK FOOTER //
// ./src/app/components/new-film.jsx